import { IcebergIcon } from '@tradesolution/iceberg-ui-react';
import useCopyToClipboard from 'utils/hooks/useCopyToClipboard';

interface Props {
  val: string | number;
  showDesc?: boolean;
}

const CopyToClipboardIcon = (props: Props) => {
  const { handleCopy, isCopied } = useCopyToClipboard(3000);

  return (
    <div style={{ cursor: 'pointer' }} onClick={() => handleCopy(props.val)}>
      {props.showDesc && <span className="text-muted">{isCopied ? 'kopiert' : 'kopier'} </span>}
      <IcebergIcon size="16px" icon={isCopied ? 'check' : 'copy-to-clipboard'} />
    </div>
  );
};

export default CopyToClipboardIcon;
